// import { Team } from "src/common-services";
import React, { Component } from "react";
import { PlayerCardButton } from "src/components/PlayerCard/PlayerCardButton";

import PlayerImage from "../PlayerImage";
import PlayerInjuryStatusItem from "../PlayerInjuryStatusItem";
import styles from "./styles.scss";
import { PlayerCardName } from "src/components/PlayerCard/PlayerCardName";

interface PlayerInjuryItemProps {
  team: any;
  injuredPlayer: any;
}

/**
 * Player injury line item - mobile ready.
 * This displays the headshot of the player, their position, the injury acronym and any injury news
 * Depending on the screen size and the overflow of the injury news the user will be provided with a
 * show more button (only shown on small screens).
 */
export default class PlayerInjuryItem extends Component<PlayerInjuryItemProps, {}> {
  render() {
    const { injuredPlayer, team } = this.props;
    const analysis: string = injuredPlayer.news ? injuredPlayer.news.analysis : "No details provided";

    const title: string = injuredPlayer.news ? injuredPlayer.news.title : "";

    return (
      <div className="rotoql-player-injury__container">
        <PlayerCardButton className="rotoql-player-injury__card-button" player={injuredPlayer}>
          <PlayerImage
            url={injuredPlayer.imageUrl}
            size={64}
            containerClassName="rotoql-player-injury__image-container"
          />
          <div className="rotoql-player-injury__info-container">
            <div>
              <PlayerCardName className="rotoql-player-injury__player-name">{injuredPlayer.fullName}</PlayerCardName>
              <span className="rotoql-player-injury__team-position">
                {team.preferredAbbreviation}
                {injuredPlayer.position && ` | ${injuredPlayer.position}`}
              </span>
            </div>
            <div className="rotoql-player-injury__team-news-title">{title}</div>
            <div>{analysis}</div>
          </div>
        </PlayerCardButton>
        <div>
          <PlayerInjuryStatusItem injuryStatus={injuredPlayer.injuryStatus} />
        </div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}
